import { AxiosResponse } from "axios";
import { call, put, select, takeLatest } from "redux-saga/effects";
import { AppService } from "src/services/app";
import { getBaseUrl } from "../selectors/features/app";
import {
  createStripePaymentMethodFailure,
  createStripePaymentMethodSuccess
} from "../slices/features/stripePaymentMethod";
import { RequestTypes } from "../types";

const appservice = new AppService();

function* createStripePaymentMethodSaga(action: any) {
  const { payload } = action;
  const { id, paymentMethodId } = payload;

  try {
    const baseUrl: string = yield select(getBaseUrl);

    const response: AxiosResponse<any> = yield call(
      appservice.createStripePaymentMethod,
      baseUrl,
      id,
      paymentMethodId
    );

    yield put(createStripePaymentMethodSuccess({ ...response }));

    let paymentMethodData = {};
    if (response.data) {
      paymentMethodData = response.data;
    }

    payload?.cbSuccess && payload?.cbSuccess(paymentMethodData);
  } catch (error: any) {
    const { statusCode, statusText } = error;
    yield put(createStripePaymentMethodFailure({ statusCode, statusText }));
  }
}

export function* watchCreateStripePaymentMethod() {
  yield takeLatest(
    RequestTypes.CREATE_STRIPE_PAYMENT_METHOD_REQUEST,
    createStripePaymentMethodSaga
  );
}
